module.exports = __webpack_public_path__ + "img/mission.841d1fbb.jpg";